'use client';

import {
  createContext,
  useContext,
} from 'react';

import { UseModalReturn } from './useModal';

type ContextType = UseModalReturn | null;

export const ModalContext = createContext<ContextType>(null);

export const useModalContext = (): UseModalReturn => {
  const context = useContext(ModalContext);

  if (context == null) {
    throw new Error('Modal components must be wrapped in <Modal />');
  }

  return context;
};
